module.exports = __webpack_public_path__ + "static/img/ultah.421e87a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/antarmuka-user/img/ultah.png
// module id = uzHJ
// module chunks = 1